<script lang="ts" setup>
import debounce from "lodash.debounce";

const documentId = inject("documentId") as any;
const submittedDocumentStore = useSubmittedDocumentStore(documentId);
const { saveRevision, updateDocumentState } = submittedDocumentStore;
const { revision, showGeneralCommentForm } = storeToRefs(
  submittedDocumentStore
);

const leftCoordinates = ref();

const calculateLeftCoordinates = () => {
  leftCoordinates.value = useDocumentContainerRightPosition() - 82 + "px";
};

calculateLeftCoordinates();

onMounted(() => {
  window.addEventListener("resize", calculateLeftCoordinates);
  calculateLeftCoordinates();
});

onUnmounted(() => {
  window.addEventListener("resize", calculateLeftCoordinates);
});

const onUpdate = (ev: any) => {
  const r = revision.value!;
  r.commentObject = ev;

  saveRevision(r);
};

const close = () => {
  showGeneralCommentForm.value = false;
};

const debounceOnUpdate = debounce(onUpdate, 1000);
</script>

<template>
  <Transition>
    <div
      v-if="showGeneralCommentForm"
      class="absolute top-[60px] p-4 z-[90]"
      :style="{
        height: 'calc(100% - 60px)',
        left: leftCoordinates,
      }"
    >
      <div
        class="flex flex-col rounded shadow bg-white p-4 w-[500px] h-full overflow-auto"
      >
        <h2 class="text-h4 mb-2">General Feedback</h2>
        <BaseSelectInput :options="RevisionCommentPlacementOptions" />
        <BaseDocumentTextEditor
          class="mb-2 max-h-[400px]"
          :model-value="revision?.commentObject"
          @update:model-value="debounceOnUpdate"
          :show-formatting-options="true"
          :auto-focus="true"
          @on-save="debounceOnUpdate"
          @on-close="close"
        ></BaseDocumentTextEditor>

        <div class="grow">&nbsp;</div>
        <div class="flex flex-row mt-2 items-center justify-between h-[42px]">
          <span class="flex flex-row items-center">
            <BaseButton class="w-[140px] mr-2" @click="close()"
              >Done</BaseButton
            >
            <BaseTextButton color="danger" @click="close"
              >cancel</BaseTextButton
            >
          </span>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped></style>
